@if (mode !== 'read' && surveyData?.srvyMsg) {
  <div [innerHTML]="surveyData?.srvyMsg" class="notranslate" translate="no" style="margin-bottom: 20px;"></div>
}

@if (parsedQuestions.length) {
<form nz-form [formGroup]="form" class="notranslate" translate="no">
  <ng-template #inlineBlock let-inlineQ="q">
    <div class="inline-subquestion">
      <div class="inline-subquestion-label">{{ getQuestionLabel(inlineQ) }}</div>

      @if (inlineQ.qtype === 'text') {
        <input nz-input [formControlName]="inlineQ.qid" [placeholder]="getPlaceholder(inlineQ)" />
        @for (subQ of getSubQuestions(inlineQ.qid); track $index) {
          @if (isVisible(subQ)) {
            <ng-container [ngTemplateOutlet]="inlineBlock" [ngTemplateOutletContext]="{q: subQ}"></ng-container>
          }
        }
      }
      @if (inlineQ.qtype === 'textarea') {
        <textarea nz-input [formControlName]="inlineQ.qid" rows="3" [placeholder]="getPlaceholder(inlineQ)"></textarea>
        @for (subQ of getSubQuestions(inlineQ.qid); track $index) {
          @if (isVisible(subQ)) {
            <ng-container [ngTemplateOutlet]="inlineBlock" [ngTemplateOutletContext]="{q: subQ}"></ng-container>
          }
        }
      }
      @if (inlineQ.qtype === 'radio') {
        <nz-radio-group [formControlName]="inlineQ.qid">
          @for (innerOpt of inlineQ.options; track $index) {
          <label nz-radio [id]="inlineQ.qid + '_' + getOptValue(innerOpt)" [attr.for]="inlineQ.qid + '_' + getOptValue(innerOpt)" [nzValue]="getOptValue(innerOpt)">
            {{ getOptLabel(innerOpt) }}
          </label>
          @for (nestedQ of getInlineQuestions(inlineQ.qid, getOptValue(innerOpt)); track $index) {
            @if (isVisible(nestedQ)) {
              <ng-container [ngTemplateOutlet]="inlineBlock" [ngTemplateOutletContext]="{q: nestedQ}"></ng-container>
            }
          }
          }
        </nz-radio-group>
      }
      @if (inlineQ.qtype === 'checkbox' || inlineQ.qtype === 'multiCheckbox') {
        <div class="multi-checkbox-group">
          @for (innerOpt of inlineQ.options; track $index) {
          <label nz-checkbox [id]="inlineQ.qid + '_' + getOptValue(innerOpt)" [attr.for]="inlineQ.qid + '_' + getOptValue(innerOpt)"
            [nzChecked]="form.get(inlineQ.qid)?.value?.includes(getOptValue(innerOpt))"
            [nzDisabled]="mode === 'read'"
            (nzCheckedChange)="onMultiCheckboxChange(inlineQ.qid, getOptValue(innerOpt), $event)">
            {{ getOptLabel(innerOpt) }}
          </label>
          @for (nestedQ of getInlineQuestions(inlineQ.qid, getOptValue(innerOpt)); track $index) {
            @if (isVisible(nestedQ)) {
              <ng-container [ngTemplateOutlet]="inlineBlock" [ngTemplateOutletContext]="{q: nestedQ}"></ng-container>
            }
          }
          }
        </div>
      }
      @if (inlineQ.qtype === 'date') {
        <input type="date" class="ant-input survey-date-input"
          [formControlName]="inlineQ.qid"
          [min]="getDateMinStr(inlineQ)"
          [max]="getDateMaxStr(inlineQ)" />
        @for (subQ of getSubQuestions(inlineQ.qid); track $index) {
          @if (isVisible(subQ)) {
            <ng-container [ngTemplateOutlet]="inlineBlock" [ngTemplateOutletContext]="{q: subQ}"></ng-container>
          }
        }
      }
      @if (inlineQ.qtype === 'select') {
        @if (mode === 'read') {
          <input nz-input class="read-only-input" [value]="getAnswerLabel(inlineQ)" [disabled]="true" />
        } @else {
          <ppl-dropdown-select
            [formControlName]="inlineQ.qid"
            [options]="getOptions(inlineQ)"
            optionLabel="label"
            optionValue="value"
            [placeholder]="getPlaceholder(inlineQ)">
          </ppl-dropdown-select>
        }
      }
      @if (inlineQ.qtype === 'multiselect') {
        @if (mode === 'read') {
          <input nz-input class="read-only-input" [value]="getAnswerLabel(inlineQ)" [disabled]="true" />
        } @else {
          <ppl-multiselect
            [formControlName]="inlineQ.qid"
            [options]="getOptions(inlineQ)"
            optionLabel="label"
            optionValue="value"
            [placeholder]="getPlaceholder(inlineQ)">
          </ppl-multiselect>
        }
      }
      @if (hasError(inlineQ.qid)) {
        <div class="inline-error">{{ getErrorMessage(inlineQ.qid, inlineQ.validation) }}</div>
      }
    </div>
  </ng-template>

  @for (q of parsedQuestions; track $index) {
  @if (isVisible(q) && !isInlineQuestion(q)) {

  <nz-form-item class="ppl-form-item">

    <nz-form-label [nzSm]="10" [nzXs]="24" [nzRequired]="q.required && mode !== 'read'" class="ppl-mr8">
      {{ getQuestionLabel(q) }}
    </nz-form-label>

    <nz-form-control class="ppl-form-control"
      [nzValidateStatus]="hasError(q.qid) ? 'error' : ''"
      [nzErrorTip]="getErrorMessage(q.qid, q.validation)">

      @if (q.qtype === 'radio') {
      <nz-radio-group [formControlName]="q.qid">
        @for (opt of q.options; track $index) {
        <label nz-radio [id]="q.qid + '_' + getOptValue(opt)" [attr.for]="q.qid + '_' + getOptValue(opt)" [nzValue]="getOptValue(opt)">
          {{ getOptLabel(opt) }}
        </label>
        }
      </nz-radio-group>
      @for (opt of q.options; track $index) {
        @for (inlineQ of getInlineQuestions(q.qid, getOptValue(opt)); track $index) {
          @if (isVisible(inlineQ)) {
            <ng-container [ngTemplateOutlet]="inlineBlock" [ngTemplateOutletContext]="{q: inlineQ}"></ng-container>
          }
        }
      }
      }

      @if (q.qtype === 'checkbox' || q.qtype === 'multiCheckbox') {
      <div class="multi-checkbox-group">
        @for (opt of q.options; track $index) {
        <label nz-checkbox [id]="q.qid + '_' + getOptValue(opt)" [attr.for]="q.qid + '_' + getOptValue(opt)"
          [nzChecked]="form.get(q.qid)?.value?.includes(getOptValue(opt))"
          [nzDisabled]="mode === 'read'"
          (nzCheckedChange)="onMultiCheckboxChange(q.qid, getOptValue(opt), $event)">
          {{ getOptLabel(opt) }}
        </label>
        @for (inlineQ of getInlineQuestions(q.qid, getOptValue(opt)); track $index) {
          @if (isVisible(inlineQ)) {
            <ng-container [ngTemplateOutlet]="inlineBlock" [ngTemplateOutletContext]="{q: inlineQ}"></ng-container>
          }
        }
        }
      </div>
      }

      @if (q.qtype === 'text') {
      <input nz-input [formControlName]="q.qid" [placeholder]="getPlaceholder(q)" />
      @for (subQ of getSubQuestions(q.qid); track $index) {
        @if (isVisible(subQ)) {
          <ng-container [ngTemplateOutlet]="inlineBlock" [ngTemplateOutletContext]="{q: subQ}"></ng-container>
        }
      }
      }

      @if (q.qtype === 'textarea') {
      <textarea nz-input [formControlName]="q.qid" rows="3" [placeholder]="getPlaceholder(q)"></textarea>
      @for (subQ of getSubQuestions(q.qid); track $index) {
        @if (isVisible(subQ)) {
          <ng-container [ngTemplateOutlet]="inlineBlock" [ngTemplateOutletContext]="{q: subQ}"></ng-container>
        }
      }
      }

      @if (q.qtype === 'date') {
      <input type="date" class="ant-input survey-date-input"
        [formControlName]="q.qid"
        [min]="getDateMinStr(q)"
        [max]="getDateMaxStr(q)" />
      @for (subQ of getSubQuestions(q.qid); track $index) {
        @if (isVisible(subQ)) {
          <ng-container [ngTemplateOutlet]="inlineBlock" [ngTemplateOutletContext]="{q: subQ}"></ng-container>
        }
      }
      }

      @if (q.qtype === 'select') {
        @if (mode === 'read') {
          <input nz-input class="read-only-input" [value]="getAnswerLabel(q)" [disabled]="true" />
        } @else {
          <ppl-dropdown-select
            [formControlName]="q.qid"
            [options]="getOptions(q)"
            optionLabel="label"
            optionValue="value"
            [placeholder]="getPlaceholder(q)">
          </ppl-dropdown-select>
        }
      @for (subQ of getSubQuestions(q.qid); track $index) {
        @if (isVisible(subQ)) {
          <ng-container [ngTemplateOutlet]="inlineBlock" [ngTemplateOutletContext]="{q: subQ}"></ng-container>
        }
      }
      }

      @if (q.qtype === 'multiselect') {
        @if (mode === 'read') {
          <input nz-input class="read-only-input" [value]="getAnswerLabel(q)" [disabled]="true" />
        } @else {
          <ppl-multiselect
            [formControlName]="q.qid"
            [options]="getOptions(q)"
            optionLabel="label"
            optionValue="value"
            [placeholder]="getPlaceholder(q)">
          </ppl-multiselect>
        }
      @for (subQ of getSubQuestions(q.qid); track $index) {
        @if (isVisible(subQ)) {
          <ng-container [ngTemplateOutlet]="inlineBlock" [ngTemplateOutletContext]="{q: subQ}"></ng-container>
        }
      }
      }

    </nz-form-control>

  </nz-form-item>

  }
  }
</form>

@if (mode !== 'read') {
  <div class="custom-row">
    <ppl-button label="Submit" icon="fa fa-check-circle" [customClass]="'primary-button'" [iconPosition]="'right'"
      (click)="submit()">
    </ppl-button>
  </div>
}
}
